// Canonical clean-path routing for the former /teams?tab=… hub.
// Each PWHL "Teams" tab now has its own sensible URL. Tabs that collide with an
// existing standalone page get a /team-* prefix. Team-scoped tabs support an
// optional /:teamId path segment (e.g. /rosters/bos). Legacy ?tab= links are
// auto-redirected to these via the /teams route.
export const TAB_PATHS = {
    overview: "/team-pages",
    standings: "/standings",
    schedule: "/schedule",
    leaderboards: "/team-leaderboards",
    contracts: "/contracts",
    draft: "/team-draft",
    demographics: "/team-demographics",
    transfers: "/team-movements",
    injuries: "/injuries",
    discipline: "/discipline",
    staffmoves: "/staff-moves",
    trades: "/team-trades",
    players: "/rosters",
    roster: "/active-lineup",
    records: "/team-records",
    history: "/team-history",
    staff: "/staff",
    news: "/team-news",
    videos: "/team-videos",
};

export const PATH_TABS = Object.fromEntries(
    Object.entries(TAB_PATHS).map(([k, v]) => [v, k])
);

// Tabs that render a specific team (accept an optional /:teamId path segment).
export const TEAM_SCOPED = new Set(["overview", "players", "roster", "records", "history", "staff"]);

export const TEAMS_TAB_PATHS = Object.values(TAB_PATHS);
export const TEAMS_SCOPED_PATHS = [...TEAM_SCOPED].map((t) => TAB_PATHS[t]);

export const pathForTab = (tab, team) => {
    const base = TAB_PATHS[tab] || "/standings";
    return TEAM_SCOPED.has(tab) && team ? `${base}/${team}` : base;
};

// Active PWHL tab key for the current location (clean path, else legacy ?tab=).
export const tabFromLocation = (pathname = "", search = "") => {
    const base = "/" + (pathname.split("/")[1] || "");
    if (PATH_TABS[base]) return PATH_TABS[base];
    const q = new URLSearchParams(search).get("tab");
    if (q) return q;
    return pathname.startsWith("/teams") ? "standings" : null;
};

// Convert a legacy /teams?tab=X&team=Y URL into its clean-path equivalent.
export const legacyTeamsPath = (searchParams) => {
    const tab = searchParams.get("tab") || "standings";
    const team = searchParams.get("team");
    return pathForTab(tab, team);
};
